import type { SxProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';

/**
 * Функция spreadSxProperty принимает параметр `sx` и преобразует его в массив.
 * Если `sx` уже является массивом, он возвращается без изменений.
 * Если `sx` - это одиночный объект или значение, он оборачивается в массив.
 *
 * @param {SxProps<Theme>} sx - Объект или массив стилей, которые применяются
 *                              согласно типу `SxProps<Theme>`.
 * @returns {SxProps<Theme>} Возвращает массив стилей `SxProps<Theme>`, вне зависимости
 *                           от первоначального типа входного значения.
 */
export const spreadSxProperty = (sx: SxProps<Theme>) => {
  return Array.isArray(sx) ? sx : [sx];
};
